import RouteView from "@/layouts/RouteView.vue";
export default {
  path: "/user",
  name: "UserManage",
  redirect: "/user/UserList",
  component: RouteView,
  meta: {
    title: "客户管理",
    showNavBar: false,
  },
  children: [
    {
      path: "/user/UserList",
      name: "UserList",
      component: () => import("@/views/user/UserList.vue"),
      meta: {
        title: "客户列表",
      },
    },
    {
      path: "/user/UserDetail",
      name: "UserDetail",
      component: () => import("@/views/user/UserDetail.vue"),
      meta: {
        title: "客户详情",
      },
    },
    {
      path: "/user/EditUser",
      name: "EditUser",
      component: () => import("@/views/user/EditUser.vue"),
      meta: {
        title: "编辑客户",
      },
    },
  ],
};
